<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useAttrs } from 'vue';

defineProps<{
  modelValue: string | number;
  error?: boolean;
}>();

const emit = defineEmits(['update:modelValue']);

const attrs = useAttrs();

function handleInput(event: Event) {
  const target = event.target as HTMLButtonElement;
  if (target) emit('update:modelValue', target.value);
}

const input = ref();

onMounted(() => {
  if (input.value.hasAttribute('autofocus')) {
    input.value.focus();
  }
});

defineExpose({ focus: () => input.value.focus() });
</script>

<template>
  <div class="flex flex-row">
    <input
      ref="input"
      v-bind="attrs"
      class="border-gray-300 focus:ring focus:ring-opacity-50 shadow-sm z-10"
      :class="error ? 'focus:border-red-600 focus:ring-red-600' : 'focus:ring-sybil-teal focus:border-sybil-teal'"
      style="margin-left: 1px"
      :value="modelValue"
      @input="handleInput"
    />
    <slot name="side" />
  </div>
</template>
